import { cn } from "@/lib/utils";

/**
 * Logo da Tenanci (identidade visual "logo inter"). Uma imagem por tema: no escuro, a versão branca com roxo
 * primário. Os arquivos saem de apps/web/scripts/brand-assets.mjs. `compact` mostra só a marca.
 */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  const kind = compact ? "icon" : "logo";
  const size = compact ? "h-7" : "h-7 max-w-[9.5rem]";
  return (
    <span className={cn("inline-flex shrink-0 items-center", className)}>
      <img src={`/brand/${kind}-light.png`} alt="Tenanci" className={cn(size, "w-auto object-contain object-left dark:hidden")} />
      <img src={`/brand/${kind}-dark.png`} alt="Tenanci" className={cn(size, "hidden w-auto object-contain object-left dark:block")} />
    </span>
  );
}
